"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeySerializer = exports.Key = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var Key;
(function (Key) {
    Key[Key["Uninitialized"] = 0] = "Uninitialized";
    Key[Key["EditionV1"] = 1] = "EditionV1";
    Key[Key["MasterEditionV1"] = 2] = "MasterEditionV1";
    Key[Key["ReservationListV1"] = 3] = "ReservationListV1";
    Key[Key["MetadataV1"] = 4] = "MetadataV1";
    Key[Key["ReservationListV2"] = 5] = "ReservationListV2";
    Key[Key["MasterEditionV2"] = 6] = "MasterEditionV2";
    Key[Key["EditionMarker"] = 7] = "EditionMarker";
    Key[Key["UseAuthorityRecord"] = 8] = "UseAuthorityRecord";
    Key[Key["CollectionAuthorityRecord"] = 9] = "CollectionAuthorityRecord";
    Key[Key["TokenOwnedEscrow"] = 10] = "TokenOwnedEscrow";
    Key[Key["TokenRecord"] = 11] = "TokenRecord";
    Key[Key["MetadataDelegate"] = 12] = "MetadataDelegate";
    Key[Key["EditionMarkerV2"] = 13] = "EditionMarkerV2";
    Key[Key["HolderDelegate"] = 14] = "HolderDelegate";
})(Key = exports.Key || (exports.Key = {}));
function getKeySerializer() {
    return (0, serializers_1.scalarEnum)(Key, { description: 'Key' });
}
exports.getKeySerializer = getKeySerializer;
//# sourceMappingURL=key.js.map